module.exports = __webpack_public_path__ + "media/images/front/content_review/campaign-608e8a5f4ec5ee5d652fa9f332e371af.jpg";